export default __webpack_public_path__ + "static/media/DeveloperGuidelines_TyporaDefendorerror.92a95176.png";